export*from"@preact/signals-core";export{SignalWatcher}from"./lib/signal-watcher.js";export{watch}from"./lib/watch.js";export{html,svg,withWatch}from"./lib/html-tag.js";
//# sourceMappingURL=index.js.map
